export const WIZARD_TYPE_PROJECT = 0;
export const WIZARD_TYPE_JOB = 1;
export const WIZARD_TYPE_USER = 2;
